export default class FileUploadeAbstract {
    constructor(filename) {
        this.filename = filename;
    }

    async download() {
        return this.filename;
    }

    async getFileToSend() {
        return this.filename;
    }
}
